export default function isIpad() {
  const ipadUserAgent = /iPad/.test(navigator.userAgent);
  const ipadWithDesktopAgent =
    navigator.maxTouchPoints &&
    navigator.maxTouchPoints > 2 &&
    /MacIntel/.test(navigator.platform);

  return ipadUserAgent || ipadWithDesktopAgent;
}
